var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.815 5.85306C12.0617 6.10157 12.0617 6.5045 11.815 6.75301L8.44659 10.147C8.19995 10.3955 7.80005 10.3955 7.55341 10.147L4.18499 6.75301C3.93834 6.5045 3.93834 6.10157 4.18499 5.85306C4.43163 5.60454 4.83153 5.60454 5.07817 5.85306L8 8.79702L10.9218 5.85306C11.1685 5.60454 11.5684 5.60454 11.815 5.85306Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.cbffb90c197a8a25bb2fa137e2c3c34d.svg";
export { ForwardRef as ReactComponent };